define
('pag_single',[
	'jquery'
	,
	'busy'
	// ,
	// 'stripe_checkout'
	// 'owl_slider'
	// ,
	// 'owl_slider_navigation'
	// ,
	// 'owl_slider_autoplay'
	// ,
	// 'stripe'
	// ,
],
function
(
	jquery
	,
	Busy
	// ,
	// owl_slider
	// ,
	// owl_slider_navigation
	// ,
	// owl_slider_autoplay
	// ,
	// Stripe
	// ,
	// StripeCheckout
) {



	//--
	var Pag = (function() {
		var fun            = {};
		var popups         = {};
		fun.moduleProperty = 1;
		// $.bridget( 'isotope', Isotope );

		//--
		if(typeof(window.busy) === 'undefined'){
			window.busy = Busy;
		}

		// //--
		// function stripeResponseHandler(status, response) {
		// 	//--
		// 	console.dir(response);

		// 	//-- Grab the form:
		// 	var $form = $('#payment-form');

		// 	if (response.error) {

		// 		//--
		// 		console.info('response.error', status);

		// 		//-- Show the errors on the form:
		// 		$form.find('.payment-errors').text(response.error.message);
		// 		$form.find('.submit').prop('disabled', false); // Re-enable submission

		// 	}
		// 	else
		// 	{
		// 		//--
		// 		console.info('response.success', status);

		// 		//-- Token was created!

		// 		//-- Get the token ID:
		// 		var token = response.id;

		// 		//-- Insert the token ID into the form so it gets submitted to the server:
		// 		$form.append($('<input type="hidden" name="stripeToken">').val(token));

		// 		//-- Submit the form:
		// 		// $form.get(0).submit();
		// 	}
		// };

		//--
		fun.init    = function () {

			$(document).ready(function(){


				setTimeout(function(){
					//--
					if($('#Desktop_Portada_Text_4').length>0 && $('#Desktop_Portada_Text_4').hasClass('display-none')){
						$('#Desktop_Portada_Text_4').addClass('live_exec');
						$('#Desktop_Portada_Text_4').removeClass('display-none');
						$('#Desktop_Portada_Text_4').parent().addClass('view_hide');
						$('#Desktop_Portada_Text_4').html('<a href="https://elfaro.net/es/poderes/" class="block"><img class="block" src="https://elfaro.net/themes/publication_1/theme_1/look/project/source/draw/site/dfpa/socl_poderes_misc_728x90.jpg" /></a>');
					}
					if($('#Devices_Portada_Text_4').length>0 && $('#Devices_Portada_Text_4').hasClass('display-none')){
						$('#Devices_Portada_Text_4').addClass('live_exec');
						$('#Devices_Portada_Text_4').parent().addClass('view_hide');
						$('#Devices_Portada_Text_4').removeClass('display-none');
						$('#Devices_Portada_Text_4').html('<a href="https://elfaro.net/es/poderes/" class="block"><img class="block" src="https://elfaro.net/themes/publication_1/theme_1/look/project/source/draw/site/dfpa/socl_poderes_misc_300x100.jpg" /></a>');
					}

					//--
					if($('#Desktop_Portada_Text_5').length>0 && $('#Desktop_Portada_Text_5').hasClass('display-none')){
						$('#Desktop_Portada_Text_5').addClass('live_exec');
						$('#Desktop_Portada_Text_5').removeClass('display-none');
						$('#Desktop_Portada_Text_5').parent().addClass('view_hide');
						$('#Desktop_Portada_Text_5').html('<a href="https://elfaro.net/es/poderes/" class="block"><img class="block" src="https://elfaro.net/themes/publication_1/theme_1/look/project/source/draw/site/dfpa/socl_poderes_misc_728x90.jpg" /></a>');
					}
					if($('#Devices_Portada_Text_5').length>0 && $('#Devices_Portada_Text_5').hasClass('display-none')){
						$('#Devices_Portada_Text_5').addClass('live_exec');
						$('#Devices_Portada_Text_5').removeClass('display-none');
						$('#Devices_Portada_Text_5').parent().addClass('view_hide');
						$('#Devices_Portada_Text_5').html('<a href="https://elfaro.net/es/poderes/" class="block"><img class="block" src="https://elfaro.net/themes/publication_1/theme_1/look/project/source/draw/site/dfpa/socl_poderes_misc_300x100.jpg" /></a>');
					}
				}, 1000);

				//--
				require(['note'],
					function(Note) {

						// console.log(moment.utc([2011, 0, 1, 8]));
						// console.log(moment().subtract(20, "years").format("DD/MM/YYYY"));

						//--
						if(typeof(window.note) === 'undefined'){
							// console.info('click:user__auth-> typeof(window.user_door.data(\'bs.modal\'))'+'==='+'undefined');
							window.note = Note;
						}

						//--
						window.note.Make();

					}
				);


				//--
				var isMobile = false; //initiate as false
				// device detection
				if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))){
					isMobile = true;
				}





				//--
				$('.note_view').each(function(i, jobj){
					//--
					var item = $(this);
					var text_root = item.find('.text_root');
					var text_chil = item.find('.text_child');
					var link = item.find('a.link');
					var text_chil_h = text_chil.find('.__content').height();

					//--
					// text_root.attr('data-less', text_root.height() );
					text_chil.attr('data-less', text_chil.height() );

					//--
					// text_root.attr('data-more', text_chil.find('.__content').height() );
					text_chil.attr('data-more', text_chil.find('.__content').height() );

					//--
					item.on('click', 'button.rate_dyep', function(hook){
						hook.preventDefault();

						//--
						console.log('click on a rate_dyep');


						//--
						var clic = $(this);
						var root = clic.attr('data-note-id');
						var rate = clic.attr('data-note-rate');


						//--
						if(typeof(window.note) === 'undefined'){

							//--
							window.busy.Show();

							//--
							require(['note'],
								function(Note) {

									// console.log(moment.utc([2011, 0, 1, 8]));
									// console.log(moment().subtract(20, "years").format("DD/MM/YYYY"));

									//--
									if(typeof(window.note) === 'undefined'){
										// console.info('click:user__auth-> typeof(window.user_door.data(\'bs.modal\'))'+'==='+'undefined');
										window.note = Note;
									}

									//--
									window.busy.Hide();

									//--
									window.note.Rate(root, rate);

								}
							);
						}
						else {
							//--
							window.note.Rate(root, rate);
						}

					});

					//--
					item.on('click', 'button.rate_dnop', function(hook){
						hook.preventDefault();

						//--
						console.log('click on a rate_dnop');


						//--
						var clic = $(this);
						var root = clic.attr('data-note-id');
						var rate = clic.attr('data-note-rate');


						//--
						if(typeof(window.note) === 'undefined'){

							//--
							window.busy.Show();

							//--
							require(['note'],
								function(Note) {

									// console.log(moment.utc([2011, 0, 1, 8]));
									// console.log(moment().subtract(20, "years").format("DD/MM/YYYY"));

									//--
									if(typeof(window.note) === 'undefined'){
										// console.info('click:user__auth-> typeof(window.user_door.data(\'bs.modal\'))'+'==='+'undefined');
										window.note = Note;
									}

									//--
									window.busy.Hide();

									//--
									window.note.Rate(root, rate);

								}
							);
						}
						else {
							//--
							window.note.Rate(root, rate);
						}

					});

					//--
					item.on('click', 'a', function(hook){
						hook.preventDefault();
						var clic = $(this);
						console.log('click on a link');

						//--
						// console.warn('root more: ' + text_root.attr('data-more') );
						console.warn('chil more: ' + text_chil.attr('data-more') );
						//--
						// console.warn('root less: ' + text_root.attr('data-less') );
						console.warn('chil less: ' + text_chil.attr('data-less') );


						//--
						require(['jquery-scrollto'], function() {

							$(window).stop(true).scrollTo($(clic.attr('href')), {offset: {top:-(70)}, duration:200, interrupt:true, onAfter: function(){
								// console.log($('#'+oid).height());
								//--
								if( clic.hasClass('show_more') ){
									console.log('show_more');

									//--
									// console.info('root more: ' + text_root.attr('data-more') );
									console.info('chil more: ' + text_chil.attr('data-more') );

									// text_root.removeClass('line--ss_s3x--auto');
									// text_chil.removeClass('line--ss_s3x--auto');
									// text_root.css('height', '');
									// text_chil.css('height', '');

									// text_root.addClass('line--ss_s3x--auto');
									// text_chil.addClass('line--ss_s3x--auto');

									// text_root.css('height', text_root.attr('data-more')+'px' );
									text_chil.css('height', text_chil.attr('data-more')+'px' );

									//--
									clic.removeClass('show_more');
									clic.addClass('show_less');
								}
								else
								{
									if( clic.hasClass('show_less') ){


										console.log('show_less');

										//--
										// console.info('root less: ' + text_root.attr('data-less') );
										console.info('chil less: ' + text_chil.attr('data-less') );

										// text_root.removeClass('line--ss_s3x--auto');
										// text_chil.removeClass('line--ss_s3x--auto');

										// text_root.css('height', text_root.attr('data-less')+'px' );
										text_chil.css('height', text_chil.attr('data-less')+'px' );

										clic.removeClass('show_less');
										clic.addClass('show_more');
									}
								}


							}});

						});


					});
				});


											// // [
											// // 'data1',
											// 	null, null, null, null, null, null, null, null, null, null, null,
											// 	221666.63, 0, 221666.63, 0, 255952.34, 0, 0, 221666.63, 0, 378129.38, 0, 13225.94,
											// 	233333.26, 233333.26, 476365.14, 0, 422482.52, 233333.26, 288844.35, 55511.09, 233333.26, 0, 0, 316600.8,
											// 	217000, 478238.52, 233333.26, 461904.69, 233333.26, 0, 233333.26, 0, 0, 233333.26, 0,
											// 	461904.69, 233333.26, 0, 228571.43, 0, 0, 233333.26, 233333.26, 233333.26, 228571.43, 2519047.55, 233333.26,

											// 	3347618.97, 0, 233333.26, 0, 233333.26, 0, 0, 0, 228571.43, 233333.26, 633334.4,
											// 	685714.29, 228571.42, 0, 0, 342857.14, 1349904.71, 0, 0, 461904.68, 0, 0, 873334.15,
											// 	1147618.65, 861905, 228571, 519047, 400000, 685714, 228571, 0, 400000, 804158, 877000, 542857,
											// 	503571, 533333, 461904, 233333, 260000, 808333, 0, 0, 851191, 747333, 433333, 792857,
											// 	711904, 483333, 233333, 597619, 483333, 483333, 1059523, 483333, 250000, 711904, 0, 233333,

											// 	711904, 233333, 0, 0, 0, 233333, 707144, 597619, 400000, 1361904, 883333, 1383333,
											// 	961904, 500000, 728571, 961904, 486904, 0, 0, 0, 293333, 786904, 258333, 1164528,
											// 	639620, 873620, 1426240, 0, 786904, 786904, 786904, 786904, 786904, 786904, 786904
											// // ]


				//--
				if( 0 < $('.graf_stat_area').length ){

					require([
							'jquery'
							,
							'd3v3'
							,
							'c3'
							,
							'bootstrap-toolkit'
							,
							'select2'
							,
							'hbs'
							,
							'busy'
							,
							'moment'
							,
							'moment/locale/es'
						],
						function(
							jquery
							,
							d3
							,
							c3
							,
							bootstrapToolkit
							,
							Select2
							,
							hbs
							,
							// owl_slider
							// ,
							// owl_slider_navigation
							// ,
							// owl_slider_autoplay
							// ,
							Busy
							,
							moment)
						{


							//--
							if( 0 < $('#graf_stat_moie_posa').length ){

								//--
								var chart =
								c3.generate({
									bindto: '#graf_stat_moie_posa',
									grid:
									{
										focus:
										{
											show: true
										},
										x:
										{
											lines:
											[
												{value: '199406', text: 'Calderón Sol', position: 'middle'},
												{value: '199906', text: 'Francisco Flores', position: 'middle'},
												{value: '200406', text: 'Antonio Saca', position: 'middle'},
											]
										}
									}
									,
									data:
									{
										x: 'x',
										xFormat: '%Y%m',
										columns: [
											['x',
											'199401','199402','199403','199404','199405',/* Sol*/'199406','199407','199408','199409','199410','199411','199412',
											'199501','199502','199503','199504','199505','199506','199507','199508','199509','199510','199511','199512',
											'199601','199602','199603','199604','199605','199606','199607','199608','199609','199610','199611','199612',
											'199701','199702','199703','199704','199705','199706','199707','199708','199709','199710','199711','199712',
											'199801','199802','199803','199804','199805','199806','199807','199808','199809','199810','199811','199812',
											'199901','199902','199903','199904','199905',/* Flores*/'199906','199907','199908','199909','199910','199911','199912',
											'200001','200002','200003','200004','200005','200006','200007','200008','200009','200010','200011','200012',
											'200101','200102','200103','200104','200105','200106','200107','200108','200109','200110','200111','200112',
											'200201','200202','200203','200204','200205','200206','200207','200208','200209','200210','200211','200212',
											'200301','200302','200303','200304','200305','200306','200307','200308','200309','200310','200311','200312',
											'200401','200402','200403','200404','200405',/* Saca*/ '200406','200407','200408','200409','200410','200411','200412',
											'200501','200502','200503','200504','200505','200506','200507','200508','200509','200510','200511','200512',
											'200601','200602','200603','200604','200605','200606','200607','200608','200609','200610','200611'
											],
											['data1',
												null, null, null, null, null, 0, 0, 0, 0, 0, 0, 0,
												221666.63, 0, 221666.63, 0, 255952.34, 0, 0, 221666.63, 0, 378129.38, 0, 13225.94,
												233333.26, 233333.26, 476365.14, 0, 422482.52, 233333.26, 288844.35, 55511.09, 233333.26, 0, 0, 316600.8,
												217000, 478238.52, 233333.26, 461904.69, 233333.26, 0, 233333.26, 0, 0, 233333.26, 0, 0,
												461904.69, 233333.26, 0, 228571.43, 0, 0, 233333.26, 233333.26, 233333.26, 228571.43, 2519047.55, 233333.26,
												3347618.97, 0, 233333.26, 0, 233333.26, 0, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null
											],
											['data2',
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, 228571.43, 233333.26, 633334.4, 0,
												685714.29, 228571.42, 0, 0, 342857.14, 1349904.71, 0, 0, 461904.68, 0, 0, 873334.15,
												1147618.65, 861905, 228571, 519047, 400000, 685714, 228571, 0, 400000, 804158, 877000, 542857,
												503571, 533333, 461904, 233333, 260000, 808333, 0, 0, 851191, 747333, 433333, 792857,
												711904, 483333, 233333, 597619, 483333, 483333, 1059523, 483333, 250000, 711904, 0, 233333,
												711904, 233333, 0, 0, 0, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null
											],
											['data3',
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, null, null, null, null, null, null, null,
												null, null, null, null, null, 233333, 707144, 597619, 400000, 1361904, 883333, 1383333,
												961904, 500000, 728571, 961904, 486904, 0, 0, 0, 293333, 786904, 258333, 1164528,
												639620, 873620, 1426240, 0, 786904, 786904, 786904, 786904, 786904, 786904, 786904, 0
											]
										],
										axes:
										{
										}
										,
										names:
										{
											data1: 'Gobierno Calderón Sol',
											data2: 'Gobierno Francisco Flores',
											data3: 'Gobierno Antonio Saca',
										}
										,
										labels:
										{
											format:
											{
												data1:
												function(d){
													if(d!=null && d>4000000){
														var look = '';
														if(isMobile){
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															look = '$'+look;
														}
														else
														{
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															look = '$'+look;
														}
														return ''+look;
													}
												}
												,
												data2:
												function(d){
													if(d!=null && d>4800000){
														var look = '';
														if(isMobile){
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															look = '$'+look;
														}
														else
														{
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															look = '$'+look;
														}
														return ''+look;
													}
												}
												,
												data3:
												function(d){
													if(d!=null && d>7000000){
														var look = '';
														if(isMobile){
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															look = '$'+look;
														}
														else
														{
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															look = '$'+look;
														}
														return ''+look;
													}
												}
											}
										}
									}
									,
									legend:
									{
										position: 'bottom'
									}
									,
									regions:
									[
										{
											start: '199406', end: '199906', class: 'tint-back--arm'
										}
										,
										{
											start: '199906', end: '200406', class: 'tint-back--fra'
										}
										,
										{
											start: '200406', end: '200906', class: 'tint-back--ant'
										}
									]
									,
									axis:
									{
										range:
										{
											max: {y: 8000000, x: '200906'}
											,
											min: {y: 0, x: '199406'}
										}
										,
										x:
										{
											type: 'timeseries',
											localtime: false,
											tick:
											{
												// format: '%Y/%m'
												//-- Valores
												// count: 15
												// ,
												// format: "%b/%Y",
												rotate: 65,
												fit: false
												,
												//-- Etiquetas
															culling:
												{
													min: 15
													// ,
													// max: 15
												}
												,
												format:
												function(item){
													// over = d3.format('$,');
													// look = over(d);
													var resp = false;
													// console.log('item: ', item);
													// console.log('item: ', moment(item).format("YYYY/MMM"));
													// console.log('item: ', item.getFullYear());
													// console.log('item: ', item.getMonth());
													// var look = '';
													// var sort = (d+1);
													// if(sort==1){
													//  look = '#1';
													// }
													// if(sort==2){
													//  look = '#2';
													// }
													// if(sort==3){
													//  look = '#3';
													// }
													// if(sort==4){
													//  look = '#4';
													// }
													// if(sort==5){
													//  look = '#5';
													// }
													// return ''+look;
													if(item){
														// resp = moment(item).format("YYYY/MMM");
														resp = moment(item).format("YYYY/MMM");
													}
													if(resp){
														return resp;
													}
												}
											}
											,
									//         tick:
									//         {
									//             // format: '%Y-%m-%d',
												// // this also works for non timeseries data
												// // values: ['12']
												// // ,
									// //             culling:
									// //             {
												// //   max: 4
												// // }
									//         }
									//         ,
											// categories:
											// [
											//  'Mes 1', 'Mes 2', 'Mes 3', 'Mes 4', 'Mes 5', 'Mes 6', 'Mes 7', 'Mes 8', 'Mes 9', 'Mes 10', 'Mes 11', 'Mes 12'
											// ],
											label: {
												// text: 'Meses por período',
												text: '',
												position: 'outer-center'
												// inner-right : default
												// inner-center
												// inner-left
												// outer-right
												// outer-center
												// outer-left
											}
										},
										y:
										{
											// max: 800000,
											// min: 0,
											padding: {top:50, bottom:20},
											// range: {max: {y: 8000000}, min: {y: 0}},
											tick:
											{
												fit: true,
												format:
												function(d){
													var look = '';
													if(isMobile){
														over = d3.format(",.2s");
														look = over(d);
														look = ''+look.replace('M', 'M');
														look = ''+look.replace('k', 'Mil');
														look = '$'+look;
													}
													else
													{
														// over = d3.format('$,');
														// look = over(d);
														over = d3.format(",.2s");
														look = over(d);
														look = ''+look.replace('M', 'M');
														look = ''+look.replace('k', 'Mil');
														look = '$'+look;
													}
													return ''+look;
												}
											}
											,
											label: {
												text: 'Millones de dólares',
												position: 'outer-middle'
												// inner-top : default
												// inner-middle
												// inner-bottom
												// outer-top
												// outer-middle
												// outer-bottom
											}
										}
										,
										y2:
										{
											show: false,
											// max: 800000,
											// min: 0,
											// padding: {top:0, bottom:0},
											// range: {max: {y: 5}, min: {y: 0}},
											tick:
											{
												fit: true,
												format:
												function(d){
													// return "$" + d;
													// return d3.format("$,");

													// over = d3.format('.3s');
													// over = d3.format('$,');
													// look = over(d);
													// return ''+look;
													return ''+d;
												}
											}
											,
											label: {
												text: 'Posición (top)',
												position: 'outer-middle'
												// inner-top : default
												// inner-middle
												// inner-bottom
												// outer-top
												// outer-middle
												// outer-bottom
											}
										}
									}
								});



							};


							//--
							if( 0 < $('#graf_stat_cake_a').length ){
								var chart = c3.generate({
									bindto: '#graf_stat_cake_a',
									grid:
									{
										focus:
										{
											show: true
										},
										x:
										{
											lines:
											[
												// {value: '201601', text: '', position: 'end'}
												// ,
												// {value: '201602', text: '', position: 'end'}
												// ,
												// {value: '201603', text: '', position: 'end'}
												// ,
												{value: '201604', text: 'Medidas extraordinarias', position: 'end'}
												// ,
												// {value: '201605', text: '', position: 'end'}
												// ,
												// {value: '201606', text: '', position: 'end'}
												// ,
												// {value: '201607', text: '', position: 'end'}
												// ,
												// {value: '201608', text: '', position: 'end'}
												// ,
												// {value: '201609', text: '', position: 'end'}
												// ,
												// {value: '201610', text: '', position: 'end'}
												// ,
												// {value: '201611', text: '', position: 'end'}
												// ,
												// {value: '201612', text: '', position: 'end'}

												// {value: '201601', text: 'Enero', position: 'end'}
												// ,
												// {value: '201602', text: 'Febrero', position: 'end'}
												// ,
												// {value: '201603', text: 'Marzo', position: 'end'}
												// ,
												// {value: '201604', text: 'Abril', position: 'end'}
												// ,
												// {value: '201605', text: 'Mayo', position: 'end'}
												// ,
												// {value: '201606', text: 'Junio', position: 'end'}
												// ,
												// {value: '201607', text: 'Julio', position: 'end'}
												// ,
												// {value: '201608', text: 'Agosto', position: 'end'}
												// ,
												// {value: '201609', text: 'Septiembre', position: 'end'}
												// ,
												// {value: '201610', text: 'Octubre', position: 'end'}
												// ,
												// {value: '201611', text: 'Noviembre', position: 'end'}
												// ,
												// {value: '201612', text: 'Diciembre', position: 'end'}
											]
										}
									}
									,
									data:
									{
										x: 'x',
										xFormat: '%Y%m',
										columns: [
											['x',
												'201601',
												'201602',
												'201603',
												'201604',
												'201605',
												'201606',
												'201607',
												'201608',
												'201609',
												'201610',
												'201611',
												'201612'
											],
											['data1',
												88,
												37,
												43,
												114,
												117,
												85,
												86,
												72,
												83,
												115,
												110,
												62
											]
											,
											['data2',
												21,
												11,
												16,
												23,
												30,
												14,
												19,
												12,
												6,
												14,
												12,
												14,
											],
										],
										axes:
										{
										}
										,
										names:
										{
											data1: 'PNC'
											,
											data2: 'Fuerza Armada'
										}
										,
										labels:
										{
											format:
											{
												data1:
												function(d){
													if(d!=null && d>=111){
														var look = '';
														if(isMobile){
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															// look = '$'+look;
														}
														else
														{
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															// look = '$'+look;
														}
														// if(look=='0'){
														// 	look = ''+''
														// }
														return ''+look;
													}
												}
												,
												data2:
												function(d){
													if(d!=null && d>4800000){
														var look = '';
														if(isMobile){
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															// look = '$'+look;
														}
														else
														{
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															// look = '$'+look;
														}
														return ''+look;
													}
												}
												,
												data3:
												function(d){
													if(d!=null && d>7000000){
														var look = '';
														if(isMobile){
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															// look = '$'+look;
														}
														else
														{
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															// look = '$'+look;
														}
														return ''+look;
													}
												}
											}
										}
										,
										types:
										{
											data1: 'area',
											data2: 'area',
										}
										,
										colors: {
											data1: '#ff7f0e',
											data2: '#2ca02c',
											// data1: '#1f77b4',
											// data5: '#9467bd',
											// data4: '#d62728',
										}
									}
									,
									legend:
									{
										position: 'bottom'
									}
									,
									regions:
									[
									]
									,
									axis:
									{
										range:
										{
											max: {y: 8000000, x: '200906'}
											,
											min: {y: 0, x: '199406'}
										}
										,
										x:
										{
											// padding: {left:150},
											type: 'timeseries',
											localtime: false,
											tick:
											{
												// format: '%Y/%m'
												//-- Valores
												// count: 15
												// ,
												// format: "%b/%Y",
												fit: false
												,
												//-- Etiquetas
												culling:
												{
													min: 15
													// ,
													// max: 15
												}
												,
												format:
												function(item){
													var resp = false;
													if(item){
														// resp = moment(item).format("YYYY/MMM");
														// resp = moment(item).format("YYYY/MMM");
														resp = moment(item).format("MMM");
													}
													if(resp){
														return resp;
													}
												}
											}
											,
											label: {
												text: 'MESES',
												position: 'outer-center'
												// inner-right : default
												// inner-center
												// inner-left
												// outer-right
												// outer-center
												// outer-left
											}
										},
										y:
										{
											// max: 800000,
											// min: 0,
											padding: {top:50, bottom:20},
											// range: {max: {y: 8000000}, min: {y: 0}},
											tick:
											{
												fit: true,
												format:
												function(d){
													var look = '';
													if(isMobile){
														over = d3.format(",s");
														look = over(d);
														look = ''+look.replace('M', 'M');
														look = ''+look.replace('k', 'Mil');
														look = ''+look.replace('.00', '');
														look = ''+look.replace('.0', '');
														look = ''+look.replace('0.0', '');
														// look = ''+look.replace('0', '');
														// look = '$'+look;
													}
													else
													{
														// over = d3.format('$,');
														// look = over(d);
														over = d3.format(",.2s");
														look = over(d);
														look = ''+look.replace('M', 'M');
														look = ''+look.replace('k', 'Mil');
														look = ''+look.replace('.0', '');
														look = ''+look.replace('0.0', '');
														// look = ''+look.replace('0', '');
														// look = '$'+look;
													}
													return ''+look;
												}
											}
											,
											label: {
												text: 'DENUNCIAS',
												position: 'outer-middle'
												// inner-top : default
												// inner-middle
												// inner-bottom
												// outer-top
												// outer-middle
												// outer-bottom
											}
										}
										,
										y2:
										{
											show: false,
											// max: 800000,
											// min: 0,
											// padding: {top:0, bottom:0},
											// range: {max: {y: 5}, min: {y: 0}},
											tick:
											{
												fit: true,
												format:
												function(d){
													// return "$" + d;
													// return d3.format("$,");

													// over = d3.format('.3s');
													// over = d3.format('$,');
													// look = over(d);
													// return ''+look;
													// return ''+d;
												}
											}
											,
											label: {
												text: 'Posición (top)',
												position: 'outer-middle'
												// inner-top : default
												// inner-middle
												// inner-bottom
												// outer-top
												// outer-middle
												// outer-bottom
											}
										}
									}
								});
							};

							//--
							if( 0 < $('#graf_stat_cake_b').length ){

								var chart = c3.generate({
									bindto: '#graf_stat_cake_b'
									,
								    padding:{
								        top: 40,
								        right: 20,
								        bottom: 40,
								        left: 20,
								    }
								    ,
								    data: {
								        // x: 'x',
								        columns: [
								            // ['x', 'L', 'O', 'P', 'T'],
								            // ['data1', 0, 0, 0, 0],
								            // ['data2', 0, 0, 0, 0],

								            ['data1', 3, 1, 11, 23, 24, 24],
								            ['data2', 7, 32, 98, 136, 68, 81]
								        ]
								        ,
										names:
										{
											data1: 'Antes de las medidas'
											,
											data2: 'Después de las medidas'
										}
										,
										labels:
										{
											format:
											{
												data1:
												function(d){
													if(d!=null && d>=10){
														var look = '';
														if(isMobile){
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															// look = '$'+look;
														}
														else
														{
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															// look = '$'+look;
														}
														// if(look=='0'){
														// 	look = ''+''
														// }
														return ''+look;
													}
												}
												,
												data2:
												function(d){
													if(d!=null && d>10){
														var look = '';
														if(isMobile){
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															// look = '$'+look;
														}
														else
														{
															over = d3.format(",.2s");
															look = over(d);
															look = ''+look.replace('M', 'M');
															look = ''+look.replace('k', 'Mil');
															// look = '$'+look;
														}
														return ''+look;
													}
												}
											}
										}
										,
										types:
										{
											data1: 'area',
											data2: 'area',
										}
										,
										colors: {
											data1: '#ff7f0e',
											data2: '#2ca02c',
											// data1: '#1f77b4',
											// data5: '#9467bd',
											// data4: '#d62728',
										}

									}
									,
									legend:
									{
										position: 'bottom'
								    }
								    ,
									grid:
									{
										focus:
										{
											show: true
										},
										x:
										{
											lines:
											[
												// {value: '201604', text: 'MEDIDAS EXTRAORDINARIAS', position: 'end'}
											]
										}
									}
									,
								    axis : {


										// range:
										// {
										// 	max: {y: 8000000, x: '200906'}
										// 	,
										// 	min: {y: 0, x: '199406'}
										// }
										// ,
										x:
										{
											// padding: {left:150},
											type: 'area',
											// localtime: false,
											// tick:
											// {
											// 	// format: '%Y/%m'
											// 	//-- Valores
											// 	// count: 15
											// 	// ,
											// 	// format: "%b/%Y",
											// 	fit: false
											// 	,
											// 	//-- Etiquetas
											// 	culling:
											// 	{
											// 		min: 15
											// 		// ,
											// 		// max: 15
											// 	}
											// 	,
											// 	format:
											// 	function(item){
											// 		var resp = false;
											// 		if(item){
											// 			// resp = moment(item).format("YYYY/MMM");
											// 			// resp = moment(item).format("YYYY/MMM");
											// 			// resp = moment(item).format("MMM");
											// 		}
											// 		if(resp){
											// 			return resp;
											// 		}
											// 	}
											// }
											// ,
								            show: true,
											tick:
											{
												fit: true,
								                format: function (item) {
								                	var text = '';
								                	console.log('item: ', item)

													if(item==0){
														// text='lulz'
														text='Zacatecoluca';
													}
													if(item==1){
														// text='lulz'
														text='Gotera';
													}
													if(item==2){
														// text='lulz'
														text='Izalco';
													}
													if(item==3){
														// text='lulz'
														text='Quezaltepeque';
													}
													if(item==4){
														// text='lulz'
														text='Chalatenango';
													}
													if(item==5){
														// text='lulz'
														text='Barrios';
													}
								                	return text;
												}
							                }
							                ,
											label: {
												text: '',
												position: 'outer-center'
												// inner-right : default
												// inner-center
												// inner-left
												// outer-right
												// outer-center
												// outer-left
											}
										},
										y:
										{
											// max: 800000,
											// min: 0,
											// padding: {top:50, bottom:20},
											// range: {max: {y: 8000000}, min: {y: 0}},
								            show: true,
											tick:
											{
												fit: true,
												format:
												function(d){
													var look = '';
													if(isMobile){
														over = d3.format(",s");
														look = over(d);
														look = ''+look.replace('M', 'M');
														look = ''+look.replace('k', 'Mil');
														look = ''+look.replace('.00', '');
														look = ''+look.replace('.0', '');
														look = ''+look.replace('0.0', '');
														// look = ''+look.replace('0', '');
														// look = '$'+look;
													}
													else
													{
														// over = d3.format('$,');
														// look = over(d);
														over = d3.format(",.2s");
														look = over(d);
														look = ''+look.replace('M', 'M');
														look = ''+look.replace('k', 'Mil');
														look = ''+look.replace('.0', '');
														look = ''+look.replace('0.0', '');
														// look = ''+look.replace('0', '');
														// look = '$'+look;
													}
													return ''+look;
												}
											}
											,
											label: {
												text: '',
												position: 'outer-middle'
												// inner-top : default
												// inner-middle
												// inner-bottom
												// outer-top
												// outer-middle
												// outer-bottom
											}
										}

								    }
								});

								// setTimeout(function () {
								//     chart.load({
								//         columns: [
								//             ['data1', 3, 1, 11, 23, 24, 24]
								//         ]
								//     });
								// }, 1000);
								// setTimeout(function () {
								//     chart.load({
								//         columns: [
								//             ['data2', 7, 32, 98, 136, 68, 81]
								//         ]
								//     });
								// }, 1000);


							}

					});
				}


			});


			// require(['stripe'],
			// 	function(Stripe) {

			// 		//--
			// 		Stripe.setPublishableKey('pk_test_NLjUo9oE4d8gUKhYmtn7ADat');
			// 		// Stripe.card.createToken({
			// 		// 	number: $('.card-number').val(),
			// 		// 	cvc: $('.card-cvc').val(),
			// 		// 	exp_month: $('.card-expiry-month').val(),
			// 		// 	exp_year: $('.card-expiry-year').val()
			// 		// }, stripeResponseHandler);

			// 		//--
			// 		var $form = $('#payment-form');
			// 		$form.submit(function(event) {
			// 			//-- Disable the submit button to prevent repeated clicks:
			// 			// $form.find('.submit').prop('disabled', true);

			// 			//-- Request a token from Stripe:
			// 			Stripe.card.createToken($form, stripeResponseHandler);

			// 			//-- Prevent the form from being submitted:
			// 			return false;
			// 		});

			// 	}
			// );

			// require(['dotdotdot'],
			// 	function(dotdotdot) {
			// 		//--
			// 		console.log('Scripts Loaded');

			// 		//--
			// 		$('.dot-ellipsis').dotdotdot({
			// 			//-- The text to add as ellipsis.
			// 			ellipsis: '...',

			// 			//-- How to cut off the text/html: 'word'/'letter'/'children'
			// 			wrap: 'word',

			// 			//-- Wrap-option fallback to 'letter' for long words
			// 			fallbackToLetter: true,

			// 			//-- jQuery-selector for the item to keep and put after the ellipsis.
			// 			after: null,

			// 			//-- Whether to update the ellipsis: true/'window'
			// 			watch: true,

			// 			//-- Optionally set a max-height, can be a number or function. If null, the height will be measured.
			// 			height: null,
			// 			// height: $('.heading--madera.text-overflow').height(),

			// 			//-- Deviation for the height-option.
			// 			tolerance: 60,

			// 			//-- Callback function that is fired after the ellipsis is added, receives two parameters: isTruncated(boolean), orgContent(string).
			// 			callback:
			// 			function( isTruncated, orgContent ) {},

			// 			lastCharacter:
			// 			{
			// 				//-- Remove these characters from the end of the truncated text.
			// 				remove: [ ' ', ',', ';', '.', '!', '?' ],
			// 				//-- Don't add an ellipsis if this array contains the last character of the truncated text.
			// 				noEllipsis: []
			// 			}
			// 		});

			// 	}
			// );


		};

		return fun;

	}());
	return Pag;
});


